import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

const LanguageToggle: React.FC<{ className?: string }> = ({ className }) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "th";

  const change = (lng: "th" | "en") => {
    if (lng !== current) i18n.changeLanguage(lng);
  };

  const base =
    "px-2 py-1 text-xs font-semibold rounded-md transition-colors";
  const active = "bg-white text-form-blue";
  const inactive = "text-white/80 hover:text-white";

  return (
    <div
      className={cn(
        "flex items-center gap-1 bg-blue-700/40 rounded-md p-0.5",
        className
      )}
      role="group"
      aria-label="Language"
    >
      <button
        type="button"
        onClick={() => change("th")}
        className={cn(base, current === "th" ? active : inactive)}
      >
        TH
      </button>
      <button
        type="button"
        onClick={() => change("en")}
        className={cn(base, current === "en" ? active : inactive)}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;